import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HiringStatus, ResourceRequestStatus } from '~/types';

export const useStyles = makeStyles(theme => ({
  container: {
    background: theme.palette.dtm.main,
    borderRadius: theme.spacing(0.5),
    textAlign: 'center',
    userSelect: 'none'
  },
  text: {
    ...theme.typography.caption,
    color: theme.palette.dtm.text,
    padding: theme.spacing(0.5, 1),
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    userSelect: 'none'
  },
  draftText: {
    fontStyle: 'italic'
  }
}));

export const showHiringStatusBadge = ({ resourceRequest }) =>
  Boolean(
    resourceRequest.requestStatus === ResourceRequestStatus.Tobehired &&
      resourceRequest.sourceMetadata?.hiringStatus ===
        HiringStatus.HiringRequested
  );

export const HiringStatusBadge = ({
  classes: classesOverrides,
  requisitionHiringStatus
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({ classes: classesOverrides });
  const ariaLabel = useMemo(() => {
    const status =
      requisitionHiringStatus || formatMessage({ id: 'hiringBadge.draft' });
    const tooltip =
      requisitionHiringStatus ||
      formatMessage({ id: 'hiringBadge.draftTooltip' });

    return formatMessage({ id: 'hiringBadge.ariaLabel' }, { status, tooltip });
  }, [requisitionHiringStatus, formatMessage]);

  const values = useMemo(() => {
    if (requisitionHiringStatus) {
      return {
        message: { hiringStatus: requisitionHiringStatus },
        tooltip: requisitionHiringStatus
      };
    }

    return {
      message: {
        hiringStatus: (
          <span className={classes.draftText}>
            {formatMessage({ id: 'hiringBadge.draft' })}
          </span>
        )
      },
      tooltip: <FormattedMessage id="hiringBadge.draftTooltip" />
    };
  }, [requisitionHiringStatus, classes.draftText, formatMessage]);

  return (
    <div className={classes.container} aria-label={ariaLabel}>
      <Tooltip title={values.tooltip}>
        <Typography className={classes.text} aria-hidden="true">
          <FormattedMessage id="hiringBadge.hiring" values={values.message} />
        </Typography>
      </Tooltip>
    </div>
  );
};

HiringStatusBadge.propTypes = {
  classes: PropTypes.object,
  requisitionHiringStatus: PropTypes.string
};

export default HiringStatusBadge;
